import React from "react";
import { Link } from "react-router-dom";
import { InlineMath, BlockMath } from "react-katex";

const CBSEMaths10 = () => {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px", fontFamily: "'Nunito', 'Poppins', sans-serif", lineHeight: "1.8", color: "#1e293b" }}>
      
      <div style={{ background: "linear-gradient(135deg, #1e3a5f, #2c5282)", borderRadius: 16, padding: "40px 30px", color: "white", marginBottom: 30, textAlign: "center" }}>
        <h1 style={{ fontSize: "32px", margin: "0 0 10px 0" }}>📐 CBSE Class 10 Mathematics — Complete Guide</h1>
        <p style={{ fontSize: "18px", opacity: 0.9, margin: "0 0 20px 0" }}>Quadratic Equations, Trigonometry, Statistics, Probability — all formulas, solved examples, and instant AI help.</p>
        <a href="https://wa.me/919731453435?text=Help%20me%20with%20Class%2010%20Maths" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "14px 32px", background: "#25D366", color: "white", borderRadius: 50, textDecoration: "none", fontWeight: "bold", fontSize: "16px" }}>
          💬 Ask Eluvent on WhatsApp
        </a>
      </div>

      <div style={{ background: "#f1f5f9", borderRadius: 12, padding: "20px", marginBottom: 30 }}>
        <h2 style={{ margin: "0 0 12px 0", fontSize: "20px" }}>📑 Jump to Chapter</h2>
        <ul style={{ columns: 2, paddingLeft: 20, margin: 0 }}>
          <li><a href="#quadratic" style={{ color: "#2c5282" }}>Quadratic Equations</a></li>
          <li><a href="#trigonometry" style={{ color: "#2c5282" }}>Trigonometry</a></li>
          <li><a href="#statistics" style={{ color: "#2c5282" }}>Statistics</a></li>
          <li><a href="#probability" style={{ color: "#2c5282" }}>Probability</a></li>
          <li><a href="#coordinate" style={{ color: "#2c5282" }}>Coordinate Geometry</a></li>
        </ul>
      </div>

      <div id="quadratic" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #7c3aed", paddingLeft: 12, fontSize: "24px" }}>1. Quadratic Equations</h2>
        <p>A quadratic equation is of the form <InlineMath math="ax^2 + bx + c = 0" /> where <InlineMath math="a \neq 0" />.</p>
        
        <h3>🔑 Key Formulas</h3>
        <div style={{ background: "#f8fafc", padding: "16px", borderRadius: 8, marginBottom: 16 }}>
          <p><strong>Quadratic Formula:</strong> <InlineMath math="x = \frac{-b \pm \sqrt{b^2 - 4ac}}{2a}" /></p>
          <p><strong>Discriminant:</strong> <InlineMath math="D = b^2 - 4ac" /></p>
          <p><strong>Nature of Roots:</strong> D &gt; 0 (real & distinct), D = 0 (real & equal), D &lt; 0 (no real roots)</p>
          <p><strong>Sum of Roots:</strong> <InlineMath math="\alpha + \beta = -\frac{b}{a}" /></p>
          <p><strong>Product of Roots:</strong> <InlineMath math="\alpha\beta = \frac{c}{a}" /></p>
        </div>

        <a href="https://wa.me/919731453435?text=Solve%20quadratic%20equation%20x%5E2%20-%205x%20%2B%206%20%3D%200" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Solve a quadratic? Ask Eluvent →
        </a>
      </div>

      <div id="trigonometry" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #7c3aed", paddingLeft: 12, fontSize: "24px" }}>2. Introduction to Trigonometry</h2>
        <p>Trigonometry deals with relationships between the sides and angles of a right-angled triangle.</p>
        
        <h3>🔑 Key Ratios</h3>
        <div style={{ background: "#f8fafc", padding: "16px", borderRadius: 8, marginBottom: 16 }}>
          <p><InlineMath math="\sin \theta = \frac{\text{Opposite}}{\text{Hypotenuse}}" /> &nbsp;&nbsp; <InlineMath math="\cos \theta = \frac{\text{Adjacent}}{\text{Hypotenuse}}" /></p>
          <p><InlineMath math="\tan \theta = \frac{\text{Opposite}}{\text{Adjacent}}" /> &nbsp;&nbsp; <InlineMath math="\cot \theta = \frac{1}{\tan \theta}" /></p>
          <p><strong>Identity:</strong> <InlineMath math="\sin^2\theta + \cos^2\theta = 1" /></p>
        </div>

        <h3>📊 Trigonometric Table</h3>
        <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center", marginBottom: 16 }}>
          <thead>
            <tr style={{ background: "#2c5282", color: "white" }}>
              <th style={{ padding: 8 }}>θ</th><th>0°</th><th>30°</th><th>45°</th><th>60°</th><th>90°</th>
            </tr>
          </thead>
          <tbody>
            <tr><td style={{ fontWeight: "bold" }}>sin</td><td>0</td><td>1/2</td><td>1/√2</td><td>√3/2</td><td>1</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>cos</td><td>1</td><td>√3/2</td><td>1/√2</td><td>1/2</td><td>0</td></tr>
            <tr><td style={{ fontWeight: "bold" }}>tan</td><td>0</td><td>1/√3</td><td>1</td><td>√3</td><td>ND</td></tr>
          </tbody>
        </table>

        <a href="https://wa.me/919731453435?text=Explain%20trigonometry%20class%2010%20sin%20cos%20tan" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Memorize the table? Ask Eluvent →
        </a>
      </div>

      <div id="statistics" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #7c3aed", paddingLeft: 12, fontSize: "24px" }}>3. Statistics</h2>
        <p>Statistics involves collecting, organizing, analyzing, and interpreting data.</p>
        
        <h3>🔑 Key Formulas</h3>
        <div style={{ background: "#f8fafc", padding: "16px", borderRadius: 8, marginBottom: 16 }}>
          <p><strong>Mean (Direct):</strong> <InlineMath math="\bar{x} = \frac{\sum f_i x_i}{\sum f_i}" /></p>
          <p><strong>Median:</strong> <InlineMath math="l + \left(\frac{\frac{n}{2} - cf}{f}\right) \times h" /></p>
          <p><strong>Mode:</strong> <InlineMath math="l + \left(\frac{f_1 - f_0}{2f_1 - f_0 - f_2}\right) \times h" /></p>
        </div>

        <a href="https://wa.me/919731453435?text=How%20to%20find%20mean%20median%20mode%20class%2010" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Mean, Median, Mode? Ask Eluvent →
        </a>
      </div>

      <div id="probability" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #7c3aed", paddingLeft: 12, fontSize: "24px" }}>4. Probability</h2>
        <p>Probability measures the likelihood of an event occurring. It ranges from 0 (impossible) to 1 (certain).</p>
        
        <h3>🔑 Key Formula</h3>
        <div style={{ background: "#f8fafc", padding: "16px", borderRadius: 8, marginBottom: 16 }}>
          <BlockMath math="P(E) = \frac{\text{Number of favorable outcomes}}{\text{Total number of possible outcomes}}" />
        </div>

        <a href="https://wa.me/919731453435?text=Explain%20probability%20class%2010%20with%20example" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Dice & card problems? Ask Eluvent →
        </a>
      </div>

      <div id="coordinate" style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #7c3aed", paddingLeft: 12, fontSize: "24px" }}>5. Coordinate Geometry</h2>
        <p>Coordinate geometry (or analytic geometry) describes geometric shapes using coordinates on a plane.</p>
        
        <h3>🔑 Key Formulas</h3>
        <div style={{ background: "#f8fafc", padding: "16px", borderRadius: 8, marginBottom: 16 }}>
          <p><strong>Distance Formula:</strong> <InlineMath math="d = \sqrt{(x_2 - x_1)^2 + (y_2 - y_1)^2}" /></p>
          <p><strong>Section Formula:</strong> <InlineMath math="(x, y) = \left(\frac{m_1x_2 + m_2x_1}{m_1 + m_2}, \frac{m_1y_2 + m_2y_1}{m_1 + m_2}\right)" /></p>
          <p><strong>Midpoint:</strong> <InlineMath math="\left(\frac{x_1 + x_2}{2}, \frac{y_1 + y_2}{2}\right)" /></p>
        </div>

        <a href="https://wa.me/919731453435?text=Explain%20coordinate%20geometry%20class%2010" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "10px 20px", background: "#25D366", color: "white", borderRadius: 20, textDecoration: "none", fontWeight: "bold", fontSize: "14px", marginTop: 10 }}>
          💬 Distance formula? Ask Eluvent →
        </a>
      </div>

      {/* FAQ */}
      <div style={{ marginBottom: 40 }}>
        <h2 style={{ borderLeft: "4px solid #7c3aed", paddingLeft: 12, fontSize: "24px" }}>❓ Frequently Asked Questions</h2>
        
        <div itemScope itemType="https://schema.org/FAQPage">
          <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question" style={{ marginBottom: 16, padding: "16px", background: "#f8fafc", borderRadius: 8 }}>
            <h3 itemProp="name" style={{ fontSize: "16px", margin: "0 0 8px 0" }}>Q: How to score 90+ in CBSE Class 10 Maths?</h3>
            <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
              <p itemProp="text" style={{ margin: 0 }}>Practice NCERT thoroughly. Memorize all formulas. Solve previous year papers. Use Eluvent on WhatsApp for instant doubt-solving anytime.</p>
            </div>
          </div>

          <div itemScope itemProp="mainEntity" itemType="https://schema.org/Question" style={{ marginBottom: 16, padding: "16px", background: "#f8fafc", borderRadius: 8 }}>
            <h3 itemProp="name" style={{ fontSize: "16px", margin: "0 0 8px 0" }}>Q: Which is the easiest chapter in Class 10 Maths?</h3>
            <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
              <p itemProp="text" style={{ margin: 0 }}>Probability and Statistics are considered relatively easier. But with Eluvent's help, every chapter becomes easy!</p>
            </div>
          </div>
        </div>
      </div>

      <div style={{ background: "#e0f2fe", borderRadius: 12, padding: "20px", marginBottom: 30, textAlign: "center" }}>
        <h3 style={{ margin: "0 0 12px 0" }}>📚 Explore Other Subjects</h3>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "center" }}>
          <Link to="/cbse-class-10-physics" style={{ padding: "10px 18px", background: "#2c5282", color: "white", borderRadius: 20, textDecoration: "none", fontSize: "14px" }}>⚡ Physics</Link>
          <Link to="/cbse-class-10-chemistry" style={{ padding: "10px 18px", background: "#2c5282", color: "white", borderRadius: 20, textDecoration: "none", fontSize: "14px" }}>🧪 Chemistry</Link>
          <Link to="/cbse-class-10-biology" style={{ padding: "10px 18px", background: "#2c5282", color: "white", borderRadius: 20, textDecoration: "none", fontSize: "14px" }}>🧬 Biology</Link>
        </div>
      </div>

      <div style={{ textAlign: "center", padding: "30px", background: "linear-gradient(135deg, #1e3a5f, #2c5282)", borderRadius: 16, color: "white" }}>
        <h2 style={{ margin: "0 0 10px 0" }}>🚀 Ready to Ace Mathematics?</h2>
        <p style={{ margin: "0 0 20px 0", fontSize: "16px" }}>Ask any question on WhatsApp and get instant, step-by-step answers from Eluvent.</p>
        <a href="https://wa.me/919731453435?text=Help%20me%20with%20CBSE%20Class%2010%20Maths" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", padding: "14px 32px", background: "#25D366", color: "white", borderRadius: 50, textDecoration: "none", fontWeight: "bold", fontSize: "16px" }}>
          💬 Start Learning on WhatsApp
        </a>
      </div>

    </div>
  );
};

export default CBSEMaths10;